<cv-loader [size]="'large'" [overlay]="true" *ngIf="isSaving || isLoadingManualAward" [ngClass]="{'cxone-loader': cvConfigurationService.isCxOne}"></cv-loader>
<ng-container *ngIf="item && item!==null">
    <div
        [ngClass]="{'container content pr-5 py-4': !isCxOne, 'cxone-add-edit-container overflow-auto h-100': cvConfigurationService.isCxOne}">
        <h4 class="text-center" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="New_Award"
            *ngIf="!isCxOne; else cxoneAddEditAwardHeader">New Award</h4>
        <ng-template #cxoneAddEditAwardHeader>
            <div class="d-flex justify-content-between add-edit-award-header py-3 mb-2">
                <span *ngIf="item.RuleID === 0" class="page-title legacy-styles-title" cvLocalizedText langSection="Manual_Awards" langKey="Create_Award">Create
                    Award</span>
                <span *ngIf="item.RuleID !== 0" class="page-title legacy-styles-title" cvLocalizedText langSection="Manual_Awards" langKey="Editing_Award">Editing
                    Award</span>
                <div class="d-flex btn-container">
                    <sol-button id="add-award" variant="basic" size="large" (click)="cancelAddEditFlow()">
                        <span cvLocalizedText langSection="Common" langKey="Cancel_Button" class="btn-header">Cancel</span>
                    </sol-button>
                    <sol-button id="add-award" variant="primary" size="large" (click)="saveManualAward()" [disabled]="isSaving">
                        <span *ngIf="item.RuleID === 0" cvLocalizedText langSection="Common" langKey="Create" class="btn-header">Create</span>
                        <span *ngIf="item.RuleID !== 0" cvLocalizedText langSection="Common" langKey="Save_Button" class="btn-header">Save</span>
                    </sol-button>
                </div>
            </div>
        </ng-template>
        <div [ngClass]="{'cxone-add-edit-container-detail overflow-auto cxone-tab-landing': cvConfigurationService.isCxOne}">
            <div class="row">
                <div class="col-1 mt-1" *ngIf="!cvConfigurationService.isCxOne">
                    <img class="ml-4" [src]="'../App_Themes/clearview-default/icons/number/circle-1.svg'">
                </div>
                <div class="col">
                    <h5 runat="server" [ngClass]="{ 'legacy-styles-section': isCxOne }" cvLocalizedText langSection="Rules_Engine" langKey="Details">Details</h5>
                    <div class="d-flex max-w-680">
                        <div class="flex-fill max-w-300 mr-2">
                            <div class="d-flex">
                                <label runat="server" cvLocalizedText langSection="Manual_Awards" [ngClass]="{ 'legacy-styles-body-default': isCxOne }"
                                    langKey="Name">Name</label>
                                <span class="ml-auto" [ngClass]="{ 'legacy-styles-body-default': isCxOne }">{{item.Name?.length}}/50</span>
                            </div>
                            <input class="form-control form-control-lg" type="text" maxlength="50" [(ngModel)]="item.Name"
                                runat="server" cvLocalizedPlaceholder langSection="Manual_Awards" placeholder="Award Name"
                                langKey="Award_Name" />
                        </div>
                        <div class="align-right-item ml-2 max-w-300">
                            <div class="d-flex">
                                <label [ngClass]="{ 'legacy-styles-body-default': isCxOne }" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Choose_Folder">
                                    Choose Folder
                                </label>
                            </div>
                            <input class="form-control max-w-300 form-control-lg" list="awards-folders" [(ngModel)]="item.Folder" maxlength="50"
                                cvLocalizedPlaceholder langSection="Left_Nav_Popup" langKey="Select_Or_Type" />
                            <datalist id="awards-folders">
                                <option *ngFor="let folder of folders" [value]="folder">
                            </datalist>
                        </div>
                    </div>
                    <div class="mt-2 max-w-680">
                        <div class="d-flex"><span runat="server" [ngClass]="{ 'legacy-styles-body-default': isCxOne }" cvLocalizedText langSection="Common"
                                langKey="Description" class="mb-2">Description</span><span
                                [ngClass]="{ 'legacy-styles-body-default': isCxOne }" class="ml-auto">{{item.Description?.length}}/300</span></div>
                        <textarea rows="3" class="form-control form-control-lg description" maxlength="300"
                            [(ngModel)]="item.Description">
                                    </textarea>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-1 mt-1" *ngIf="!cvConfigurationService.isCxOne">
                    <img class="ml-4" [src]="'../App_Themes/clearview-default/icons/number/circle-2.svg'">
                </div>
                <div class="col">
                    <h5 runat="server" [ngClass]="{ 'legacy-styles-section': isCxOne }" cvLocalizedText langSection="Manual_Awards" langKey="Add_Badge">Add Badge</h5>
                    <p runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Badge_Help" [hidden]="cvConfigurationService.isCxOne">
                        Pick from one of our system badges or create your own.
                    </p>
                    <p runat="server" [ngClass]="{ 'legacy-styles-sub-section': isCxOne }" cvLocalizedText langSection="Manual_Awards" langKey="Badge_Help_Pick" [hidden]="!cvConfigurationService.isCxOne">
                        Pick from one of our system badges.
                    </p>
                    <div class="maBadgeContainer badge-container"
                        [ngClass]="{'cxone-tab-landing': cvConfigurationService.isCxOne}">
                        <div class="maBadgeItem cursor-pointer" (click)="openCustomBadgeDialog()" *ngIf="!cvConfigurationService.isCxOne">
                            <div class="rounded-circle ml-2 mt-2 w-75 h-75 position-relative badge-img-container">
                                <div class="position-absolute badge-img">
                                    <svg class="icon-24 fill-cerulean">
                                        <use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div *ngFor="let badgeID of badgeIDs" class="maBadgeItem"
                            [ngClass]="{'selected': badgeID === item.BadgeID}" (click)="item.BadgeID = badgeID">
                            <img [src]="'../Admin/ImageResizer.aspx?imgid=' + badgeID + '&w=80&h=80'" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-1 mt-1" *ngIf="!cvConfigurationService.isCxOne">
                    <img class="ml-4" [src]="'../App_Themes/clearview-default/icons/number/circle-3.svg'">
                </div>
                <div class="col">
                    <h5 runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Add_Coins"
                        *ngIf="!cvConfigurationService.isCxOne; else cxoneAddCoinsTitle">Add Coins (Optional)
                    </h5>
                    <ng-template #cxoneAddCoinsTitle>
                        <h5 runat="server" class="legacy-styles-section" cvLocalizedText langSection="Manual_Awards" langKey="CxOne_Add_Coins">Add
                            Coins</h5>
                    </ng-template>
                    <p runat="server" [ngClass]="{ 'legacy-styles-sub-section': isCxOne }" cvLocalizedText langSection="Manual_Awards" langKey="Coins_Help">Agents use coins
                        to
                        buy
                        marketplace items, wager in games, and buy gems for avatar items.</p>
                    <div class="d-flex align-items-center">
                        <div class="input-group max-width-input-coins">
                            <div class="input-group-prepend">
                                <span class="input-group-text px-2 py-0 g-icon g-icon-coin"></span>
                            </div>
                            <input type="text" class="form-control no-spinner" placeholder="Coins" [(ngModel)]="coins" runat="server"
                                cvLocalizedText langSection="Manual_Awards" langKey="Coins" 
                                (input)="formatNumber($event)"/>
                        </div>
                        <span class="ml-3" [ngClass]="{ 'legacy-styles-body-default': isCxOne }">({{getCoinValue()}} <span [ngClass]="{ 'legacy-styles-body-default': isCxOne }" runat="server" cvLocalizedText
                                langSection="Manual_Awards" langKey="Coins_Equation">coins equals one US
                                dollar</span>)</span>
                    </div>
                </div>
            </div>
            <div class="row mt-4" *ngIf="!cvConfigurationService.isCxOne">
                <div class="col-1 mt-1">
                    <img class="ml-4" [src]="'../App_Themes/clearview-default/icons/number/circle-4.svg'">
                </div>
                <div class="col">
                    <h5 runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Add_XP">Add XP (Optional)
                    </h5>
                    <p runat="server" cvLocalizedText langSection="Manual_Awards" langKey="XP_Help">Award XP to keep
                        agents
                        engaged
                        and motivated to improve performance and develop their skills.</p>
                    <div class="d-flex">
                        <div class="input-group max-width-input">
                            <div class="input-group-prepend">
                                <span class="input-group-text px-2 py-0 g-icon g-icon-xp"></span>
                            </div>
                            <input type="number" class="form-control no-spinner" maxlength="9"
                                oninput="this.value=this.value.slice(0,this.maxLength)" placeholder="XP"
                                [(ngModel)]="item.XP" runat="server" cvLocalizedText langSection="Games" langKey="XP" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4" *ngIf="!cvConfigurationService.isCxOne">
                <div class="col-1 mt-1">
                    <img class="ml-4" [src]="'../App_Themes/clearview-default/icons/number/circle-5.svg'">
                </div>
                <div class="col">
                    <h5 runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Roles_Giving_Award">Roles
                        giving the Award</h5>
                    <p runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Award_By_Role_Step_Help">Pick
                        the roles that will be able to give this award on the Dashboard.</p>
                    <div class="d-flex">
                        <cv-multi-select [id]="'statusDropdown'" [value]="status" [autoWidth]="false"
                            [placeholder]="getLocalizationString('Roles', 'Roles')" [options]="rolesList"
                            [showEmptyState]="false" (selectionChanged)="null"
                            (selectionChanged)="onMultiSelectValueChanged($event)" [selectAllOnEmpty]="false"
                            [bulkOperations]="false" primaryKey="value" label="name" [overwritePlaceholder]="false"
                            [customStyle]="{ 'width': '100px' }" [autoWidth]="true" [showSelectAllOrNoneButtons]="true">
                        </cv-multi-select>
                    </div>
                    <div *ngIf="profilesSelected.length > 0"
                        class="list-group mt-3 selected-roles-container no-top-border-group">
                        <span *ngFor="let profile of profilesSelected" class="list-group-item list-group-item-action">
                            {{ formatProfilesSelected(profile.name, profile.numberOfUsers) }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-1 mt-1" *ngIf="!cvConfigurationService.isCxOne">
                    <img class="ml-4" [src]="'../App_Themes/clearview-default/icons/number/circle-6.svg'">
                </div>
                <div class="col">
                    <h5 runat="server" [ngClass]="{ 'legacy-styles-section': isCxOne }" cvLocalizedText langSection="Manual_Awards" langKey="Assign_Groups">Assign Groups
                    </h5>
                    <p runat="server" [ngClass]="{ 'legacy-styles-sub-section': isCxOne }" cvLocalizedText langSection="Manual_Awards" langKey="Assign_Groups_Help">Pick the
                        groups that will
                        be allowed to obtain this award.</p>
                    <button *ngIf="item.AssignedGroups == null || item.AssignedGroups.length == 0 && !cvConfigurationService.isCxOne" type="button"
                        class="btn btn-secondary" (click)="showAssingTool = true;" runat="server" cvLocalizedText
                        langSection="Manual_Awards" langKey="Select_Groups">Groups</button>
                    <sol-button *ngIf="item.AssignedGroups == null || item.AssignedGroups.length == 0 && cvConfigurationService.isCxOne" variant="basic" size="large" class="btn-icon fill-icon" (click)="openAssignModal()">
                        <span cvLocalizedText langSection="Manual_Awards" langKey="Select_Groups" class="btn-header">Groups</span>
                    </sol-button> 
                    <div *ngIf="item.AssignedGroups != null && item.AssignedGroups.length > 0"
                        class="glaeGroupList p-2 mt-2 mb-4 rounded w-100">
                        <div class="d-flex flex-row pt-1">
                            <div class="color-theUpsideDown">
                                <span class="subtitle-2" runat="server" id="glaeEmployeeHeader" cvLocalizedText
                                    langSection="Games" langKey="Employee_Groups">Employee Group(s)</span><b>: </b>
                                <span> {{ getGroupName() + "(" + item.AssignedGroups.length + ")"}}</span>
                            </div>
                            <div class="d-flex flex-row ml-auto pr-1">
                                <div class="wallboardTooltipIcon position-relative" (click)="deleteSelection()">
                                    <ng-container *ngIf="!cvConfigurationService.isCxOne; else cxoneDeleteBtn">
                                        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-cerulean p-0"><svg class="icon-16">
                                                <use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete">
                                                </use>
                                            </svg></button>
                                        <div *ngIf="localizationMessages"
                                            class="font-size-12 d-none px-1 border border-secondary position-absolute delete-groups">
                                            {{localizationMessages.get("Delete_Groups")}}</div>
                                    </ng-container>
                                    <ng-template #cxoneDeleteBtn>
                                        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-cerulean p-0"
                                            tooltipClass="edit-delete-group-tooltip" [ngbTooltip]="localizationMessages && localizationMessages.get('Delete_Groups')" placement="left"
                                            triggers="mouseenter:mouseleave">
                                            <svg class="icon-16">
                                                <use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete">
                                                </use>
                                            </svg>
                                        </button>
                                    </ng-template>
                                </div>
                                <div class="wallboardTooltipIcon position-relative pl-2" (click)="cvConfigurationService.isCxOne ? openAssignModal() : showAssingTool = true;">
                                    <ng-container *ngIf="!cvConfigurationService.isCxOne; else cxoneEditBtn">
                                        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-cerulean p-0"><svg class="icon-16">
                                                <use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit">
                                                </use>
                                            </svg></button>
                                        <div *ngIf="localizationMessages"
                                            class="font-size-12 d-none px-1 border border-secondary position-absolute edit-groups">
                                            {{localizationMessages.get("Edit_Group")}}</div>
                                    </ng-container>
                                    <ng-template #cxoneEditBtn>
                                        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-cerulean p-0" tooltipClass="edit-delete-group-tooltip" 
                                            [ngbTooltip]="localizationMessages && localizationMessages.get('Edit_Group')" placement="left" triggers="mouseenter:mouseleave">
                                            <svg class="icon-16">
                                                <use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                                            </svg>
                                        </button>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-row mt-3">
                            <div class="d-flex flex-row w-100">
                                <div class="col-4 px-1" *ngFor="let row of newDataArray">
                                    <div *ngFor="let item of row">
                                        <div class="wallboardTooltipIcon position-relative px-0 py-1">
                                            <span class="glaeLongGroupName body-2">{{item.GroupName}}</span>
                                            <div
                                                class="font-size-12 d-none px-1 border border-secondary position-absolute group-name">
                                                {{item.GroupName}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="item.AssignedGroups.length > 21" class="d-flex flex-row mt-2">
                            <div *ngIf="!groupsExpanded" class="ml-auto pr-1">
                                <div class="color-cerulean clickable body-2" (click)="expandList()" runat="server"
                                    cvLocalizedText langSection="Broadcasts" langKey="See_More">See more</div>
                            </div>
                            <div *ngIf="groupsExpanded" class="ml-auto pr-1">
                                <div class="color-cerulean clickable body-2" (click)="expandList()" runat="server"
                                    cvLocalizedText langSection="Broadcasts" langKey="See_Less">See less</div>
                            </div>
                        </div>
                    </div>
                    <cv-angular-assign-tool [buttonText]="getLocalizationString('Assign','Assign')" type="awardsAddEdit"
                        showTypes="emp" [showAll]="true" [singleAdd]="false" [singleType]="true" [showParent]="true"
                        [headerText]="getLocalizationString('Assign_Groups', 'Assign Groups')"
                        [(showPopup)]="showAssingTool" [(dataTransfer)]="item.AssignedGroups"
                        (dataTransferChange)="onAssignmentsChanged($event)"></cv-angular-assign-tool>
                    <cv-custom-badge-creator [hidden]="!customBadgeCreatorVisible" [badgeType]="'award'"
                        [showWhen]="customBadgeCreatorVisible" (onCancel)="customBadgeCreatorVisible = false"
                        (onSave)="customBadgeSaved($event)">
                    </cv-custom-badge-creator>
    
                </div>
            </div>
            <div class="row mt-4" *ngIf="!cvConfigurationService.isCxOne">
                <div class="col-1 mt-1">
                    <img class="ml-4" [src]="'../App_Themes/clearview-default/icons/number/circle-7.svg'">
                </div>
                <div class="col">
                    <h5 runat="server" cvLocalizedText langSection="Award_Limit" langKey="Award_Limit_Title">Award Limit
                    </h5>
                    <div class="award-limit-input">
                        <span class="award-limit-description" runat="server" cvLocalizedText langSection="Award_Limit"
                            langKey="Award_Limit_Description_Step">How many times can the Role(s) selected give this
                            award from the dashboard.</span>
                        <input class="form-control no-spinner award-limit-input-styles" type="text"
                            [(ngModel)]="item.awardLimitValue" [disabled]="item.isUnlimited"
                            (input)="validateAwardLimitInput($event)" (keypress)="onlyNumberKey($event)" />
                        <span runat="server" cvLocalizedText langSection="Award_Limit" langKey="Per">per:</span>
                        <select class="form-control form-control-lg form-control-gray w-25"
                            [(ngModel)]="item.awardLimitPeriod" [disabled]="item.isUnlimited">
                            <option runat="server" cvLocalizedText langSection="Award_Limit" langKey="Select" value=""
                                disabled selected>Select</option>
                            <option runat="server" cvLocalizedText langSection="Award_Limit" langKey="All_Time"
                                value="allTime">All time</option>
                            <option runat="server" cvLocalizedText langSection="Award_Limit" langKey="Week" value="week">
                                Week</option>
                            <option runat="server" cvLocalizedText langSection="Award_Limit" langKey="Month" value="month">
                                Month</option>
                            <option runat="server" cvLocalizedText langSection="Award_Limit" langKey="Quarter"
                                value="quarter">Quarter</option>
                        </select>
                        <div class="challenges-settings-group-radio px-1 pt-1">
                            <div class="form-check pl-2 pt-1">
                                <input type="checkbox" [(ngModel)]="item.isUnlimited" (change)="resetLimitValues()"
                                    [value]="true" />
                                <label runat="server" cvLocalizedText langSection="Award_Limit"
                                    langKey="Unlimited">Unlimited</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4" *ngIf="!cvConfigurationService.isCxOne">
                <div class="col-1 mt-1">
                    <img class="ml-4" [src]="'../App_Themes/clearview-default/icons/number/circle-8.svg'">
                </div>
                <div class="col">
                    <h5 runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Award_Duration">Award
                        Duration
                    </h5>
                    <p runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Award_Duration_Help">Pick the
                        duration of the award's availability on the dashboard.</p>
                    <div class="d-flex">
                        <div class="input-group" style="max-width: 150px;">
                            <label class="w-25" cvLocalizedText langSection="Manual_Awards"
                                langKey="Award_Duration_From">From</label>
                            <cv-baremetrics-calendar class="d-block daterange daterange--single calendar" mode="single"
                                [required]="true" [earliestDate]="earliestDate" [latestDate]="latestDate"
                                [placeholder]="datePlaceHolder()" [(currentDate)]="startDate" [inputFormat]="'YYYY-MM-DD'"
                                (dateChanged)="handleStartDateChanged($event)" (mouseenter)="removeContentEditable($event)">
                            </cv-baremetrics-calendar>
                        </div>
                        <div class="input-group select-to-container" [class.disabled-section]="ongoingState"
                            style="max-width: 150px;">
                            <label class="w-25" cvLocalizedText langSection="Manual_Awards"
                                langKey="Award_Duration_To">To</label>
                            <cv-baremetrics-calendar class="d-block daterange daterange--single" mode="single"
                                [required]="false" [earliestDate]="earliestDateforTo" [currentDate]="item?.EndDate"
                                [placeholder]="datePlaceHolder()" (currentDate)="item.EndDate" [inputFormat]="'YYYY-MM-DD'"
                                (dateChanged)="handleEndDateChanged($event)" (mouseenter)="removeContentEditable($event)">
                            </cv-baremetrics-calendar>
                        </div>
                        <div class="d-flex align-items-center chk-ongoing">
                            <input id="chkOngoing" type="checkbox" class="p-1" [(ngModel)]="ongoingState"
                                (change)="onCheckboxChange()" />
                            <label for="chkOngoing" class="pl-1 m-0" cvLocalizedText langSection="Manual_Awards"
                                langKey="Award_Duration_Ongoing">Ongoing</label>
                        </div>
                    </div>
                    <div class="d-flex mt-2">
                        <p runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Award_Duration_Ongoing_Help">
                            Count will begin at 12:00 AM on the start date and go until 11:59 PM on the end date.</p>
                    </div>
                </div>
            </div>
    
            <div class="d-flex" *ngIf="!cvConfigurationService.isCxOne">
                <button type="button" class="btn btn-text mr-2 ml-auto" (click)="cancelAddEditFlow();" runat="server"
                    cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="saveManualAward();"
                    [disabled]="isSaving || isLoadingManualAward">
                    <span cvLocalizedText langSection="Common" langKey="Save_Button">Save</span>
                </button>
            </div>
        </div>
    </div>
</ng-container>
